$().ready(mainfunc());

function mainfunc(){

    console.log("test desu");

}
